import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./components/ProtectedRoute.tsx";
import { PageSpinner } from "./components/ui/Spinner.tsx";
import LoginPage from "./pages/LoginPage.tsx";
import DevicesPage from "./pages/DevicesPage.tsx";

// Monaco + Recharts are heavy — split them out so the registry's first paint
// stays small. The chunk loads on first navigation to /devices/:mac.
const OverviewPage = lazy(() => import("./pages/OverviewPage.tsx"));
const DeviceDetailPage = lazy(() => import("./pages/DeviceDetailPage.tsx"));
const LiveMonitorPage = lazy(() => import("./pages/LiveMonitorPage.tsx"));
const FirmwareManagerPage = lazy(() => import("./pages/FirmwareManagerPage.tsx"));
const ConfigTemplatesPage = lazy(() => import("./pages/ConfigTemplatesPage.tsx"));
const SettingsPage = lazy(() => import("./pages/SettingsPage.tsx"));
const ParametersPage = lazy(() => import("./pages/ParametersPage.tsx"));

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DevicesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/overview"
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageSpinner />}>
              <OverviewPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/devices/:mac"
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageSpinner />}>
              <DeviceDetailPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/live"
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageSpinner />}>
              <LiveMonitorPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/firmware"
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageSpinner />}>
              <FirmwareManagerPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/templates"
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageSpinner />}>
              <ConfigTemplatesPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/parameters"
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageSpinner />}>
              <ParametersPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageSpinner />}>
              <SettingsPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
